import { useEffect, useState, type FC, type PropsWithChildren } from "react";
import { useSetRecoilState } from "recoil";

import { AppBootstrapLoader } from "@ryde/controls";
import { useFullTranslationsSession } from "@ryde/redux";
import {
  enableFullTranslations,
  i18nInitializedInstance,
  initializeAuthTokens,
  isLoggedInAtom,
  isLoginPage,
  isSessionGateLoaderAtom,
  Log,
  storeCurrentPageAndRedirectToLogin,
} from "@ryde/shared";

export const AuthInitWrapper: FC<PropsWithChildren> = ({ children }) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const setIsLoggedIn = useSetRecoilState(isLoggedInAtom);
  const setIsSessionGateLoader = useSetRecoilState(isSessionGateLoaderAtom);
  useFullTranslationsSession();

  useEffect(() => {
    const init = async (): Promise<void> => {
      try {
        const { isAuthenticated } = await initializeAuthTokens();

        if (isAuthenticated) {
          // Logged-in screens read the full catalogue, so it loads before they render.
          await enableFullTranslations(i18nInitializedInstance);
          setIsSessionGateLoader(true);
          setIsLoggedIn(true);
        }
      } catch (error) {
        Log.error("Failed to initialize auth tokens:", error);
        setIsLoggedIn(false);
        setIsSessionGateLoader(false);

        if (!isLoginPage()) {
          Log.debug("Error on auth, navigating to login");
          storeCurrentPageAndRedirectToLogin();
        }
      } finally {
        setIsInitialized(true);
      }
    };

    init();
  }, [setIsLoggedIn, setIsSessionGateLoader]);

  if (!isInitialized) {
    return <AppBootstrapLoader />;
  }

  return <>{children}</>;
};
